import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  initialized: false,
  aberrations: [],
  selectedAberration: null,
  mode: "view",
};

export const aberrationManagement = createSlice({
  name: "aberration_management",
  initialState,
  reducers: {
    initializeAberrationList: (state, action) => {
      state.aberrations = action.payload;
      state.initialized = true;
    },

    addAberration: (state, action) => {
      state.aberrations = [action.payload, ...state.aberrations];
    },

    updateAberration: (state, action) => {
      state.aberrations = state.aberrations.map((item) => {
        if (item.aberration_id === action.payload.aberration_id) {
          return { ...item, ...action.payload };
        }

        return item;
      });
    },

    removeAberration: (state, action) => {
      state.aberrations = state.aberrations.filter((item) => {
        return item.aberration_id !== action.payload;
      });
    },

    setSelectedAberration: (state, action) => {
      state.selectedAberration = action.payload || null;
    },

    setAberrationMode: (state, action) => {
      if (action.payload === "new") {
        state.selectedAberration = "";
      }

      if (action.payload === "view" && state.mode === "new") {
        state.selectedAberration = null;
      }

      state.mode = action.payload;
    },
  },
});

export const {
  initializeAberrationList,
  addAberration,
  setSelectedAberration,
  setAberrationMode,
  updateAberration,
  removeAberration,
} = aberrationManagement.actions;

export const selectAberrationManagementData = (state) => ({
  ...state.aberration_management,
});

export default aberrationManagement.reducer;
